module.exports = new __parcel__URL__("Mission-Dolores-Park.f6b361f6.webp").toString();